import { isTagBadgeColour } from '@/shared/data/tagBadgeColours';
import { isLightTheme } from '@/theme/semanticTokens';
import { r, s } from '@/theme/tokens';
import { resolveLightTagBadgeStyle } from '@/ui/composites/tags/tagBadgePresentation';
import { resolveFormFieldBackgroundColor } from '@/ui/primitives/formFieldVariants';
import type { ColourSwatchOption } from './ColourSwatchSelector';
import type { SxProps, Theme } from '@/ui/primitives';

export const colourSwatchSelectorSwatchSize = '18px';
export const colourSwatchSelectorSwatchRadius = r('sm');
export const colourSwatchSelectorFieldBackgroundColor = resolveFormFieldBackgroundColor('settings');

export const colourSwatchSelectorSwatchSx = {
  display: 'inline-flex',
  width: colourSwatchSelectorSwatchSize,
  height: colourSwatchSelectorSwatchSize,
  minWidth: colourSwatchSelectorSwatchSize,
  minHeight: colourSwatchSelectorSwatchSize,
  maxWidth: colourSwatchSelectorSwatchSize,
  maxHeight: colourSwatchSelectorSwatchSize,
  flex: '0 0 auto',
  boxSizing: 'border-box',
  borderRadius: colourSwatchSelectorSwatchRadius,
  border: '1px solid',
  borderColor: 'divider',
} as const;

type ColourSwatchSelectorSwatchColourSx = {
  backgroundColor: string | ((theme: Theme) => string);
  borderColor: string | ((theme: Theme) => string);
};

export const buildColourSwatchSelectorSwatchSx = <TValue extends string>(
  option: ColourSwatchOption<TValue>,
): ColourSwatchSelectorSwatchColourSx => ({
  backgroundColor: (theme: Theme) =>
    isLightTheme(theme) && isTagBadgeColour(option.value)
      ? resolveLightTagBadgeStyle(option.value).backgroundColor
      : option.swatch,
  borderColor: (theme: Theme) =>
    isLightTheme(theme) && isTagBadgeColour(option.value)
      ? resolveLightTagBadgeStyle(option.value).borderColor
      : 'divider',
});

export const buildColourSwatchSelectorSwatchFrameSx = (
  colourSx: ColourSwatchSelectorSwatchColourSx,
): SxProps<Theme> => ({
  display: 'inline-flex',
  width: colourSwatchSelectorSwatchSize,
  height: colourSwatchSelectorSwatchSize,
  minWidth: colourSwatchSelectorSwatchSize,
  minHeight: colourSwatchSelectorSwatchSize,
  maxWidth: colourSwatchSelectorSwatchSize,
  maxHeight: colourSwatchSelectorSwatchSize,
  flex: '0 0 auto',
  boxSizing: 'border-box',
  borderRadius: colourSwatchSelectorSwatchRadius,
  border: '1px solid',
  backgroundColor: colourSx.backgroundColor,
  borderColor: colourSx.borderColor,
});

export const colourSwatchSelectorMenuItemSx = {
  minHeight: '28px',
  height: '28px',
  px: s('md'),
  py: s('none'),
  justifyContent: 'center',
  borderRadius: r('none'),
} as const satisfies SxProps<Theme>;
